import styles from './TeamsEmpty.module.css'
import { Button } from '@/components/Button'
import {
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateIllustration,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { byDesign } from '@/infra/design'
import imgNoTeamsUrl from '@/assets/misc/img_no-teams.svg'
import NoTeamsIllustration from '@/components/SpotIllustration/NoTeamsIllustration'

export interface TeamsEmptyProps {
  onCreateTeamRequest: () => void
  showCreateActions: boolean
  corporateMode: boolean
}

export function TeamsEmpty({
  onCreateTeamRequest,
  showCreateActions,
  corporateMode,
}: TeamsEmptyProps) {
  return (
    <div className={styles.root}>
      <EmptyState>
        {!corporateMode && (
          <EmptyStateIllustration
            src={imgNoTeamsUrl}
            illustration={byDesign(undefined, NoTeamsIllustration)}
          />
        )}
        <EmptyStateTitle>Looking a little empty...</EmptyStateTitle>
        <EmptyStateDescription>
          This workspace has no teams{' '}
          {showCreateActions && (
            <>
              <br /> Lets go create one.
            </>
          )}
        </EmptyStateDescription>
        {showCreateActions && (
          <EmptyStateActions>
            <Button
              label="Create Team"
              variant="primary"
              onPress={onCreateTeamRequest}
            />
          </EmptyStateActions>
        )}
      </EmptyState>
    </div>
  )
}
